import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { useAppSelector } from '../../data/store'
import { appSelectors } from '../../data/store/AppStore'
import { creditApplicationEffects } from '../../data/store/CreditApplicationStore'
import { useSideEffect } from '../../data/store/Effects/side-effects'
import { CustomerFeedback } from '../../data/types/CustomerFeedback'
import FeedbackOption from '../CustomerFeedback/FeedbackOption'

function BadReviewPage() {
  const { t } = useTranslation()
  const { id } = useParams()
  const dispatchEffect = useSideEffect()
  const navigate = useNavigate()

  const language = t('common.language')
  const badReviewReasons = useAppSelector(appSelectors.getBadReviewReasons)
  const [selectedReason, setSelectedReason] = useState('')

  const handleReasonSelected = (badReviewId: string) => {
    setSelectedReason(badReviewId)
  }
  const handleSubmit = (event: { preventDefault: () => void }) => {
    if (selectedReason === 'OTHER') {
      window.location.href = `https://ifinancecanada.com/${language}/contact/`
    } else {
      const dto: CustomerFeedback = {
        withdrawalReasonId: null,
        badReviewReasonId: selectedReason,
        contactClient: false,
        isSatisfied: false,
      }
      dispatchEffect(creditApplicationEffects.postCustomerFeedback(dto, id as string)).then(() =>
        navigate(`/creditApplication/${id as string}/feedback-page`, { replace: true }),
      )
    }

    event.preventDefault()
  }

  return (
    <main className="form-section">
      <form onSubmit={handleSubmit} style={{ textAlign: 'center', marginTop: '-10%' }}>
        <div className="control-group">
          <h1 style={{ margin: '2rem auto' }}>{t<string>('feedback.formTitle')}</h1>
          <div className="paragraphe">
            <p style={{ margin: '3rem auto' }}>{t<string>('feedback.formSubtitle')}</p>
          </div>
          {badReviewReasons?.map((r) => (
            <FeedbackOption
              key={r.id}
              id={r.id}
              text={r.text}
              selected={selectedReason}
              onChange={handleReasonSelected}
            />
          ))}
          <div style={{ textAlign: 'end' }}>
            <button type="submit" className="btn btn-blue" disabled={false} style={{ margin: '1rem auto' }}>
              <span>{t('common.submit')}</span>
              <i className="fa-regular fa-arrow-right" />
            </button>
          </div>
        </div>
      </form>
    </main>
  )
}

export default BadReviewPage
